var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common",class:_vm.map[_vm.status].class},[(_vm.map[_vm.status].icon != '')?_c('img',{attrs:{"src":_vm.map[_vm.status].icon}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.map[_vm.status].text))])])}
var staticRenderFns = []

export { render, staticRenderFns }